// oxlint-disable typescript/no-explicit-any
import type { SliceDefinition } from '../../../canvas/core';
import { createPageSelectionSlice } from './slice';

export const withPageSelectionSlice = <
  const T extends readonly SliceDefinition<any, any>[],
>(
  slices: T
): readonly [typeof createPageSelectionSlice, ...T] => [
  createPageSelectionSlice,
  ...slices,
];
